import type { ForwardedRef } from "react";
import { forwardRef } from "react";
import { clsx } from "clsx";
import type { InputProps } from "../atoms";
import { ErrorMessage, Input, SpacingY } from "../atoms";

export type InputWithErrorProps = {
  error?: string | undefined;
  fullWidth?: boolean;
} & InputProps

export const InputWithError = forwardRef(
  ({ error, fullWidth, ...props }: InputWithErrorProps, ref: ForwardedRef<HTMLInputElement>) => (
    <div
      className={clsx("flex flex-col", {
        "w-full": fullWidth,
      })}>
      <Input {...props} error={error} ref={ref} />
      <SpacingY level={2} />
      <ErrorMessage error={error} size="xs" />
    </div>
  ),
);

InputWithError.displayName = "InputWithError";
